import React from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';



import {Email, Phone, WhatsApp} from '@material-ui/icons'
const useStyles = makeStyles({
    root: {
        // flexGrow: 1,
        // maxWidth: 500,
        display: 'flex',
        flexDirection: 'column'
    },
});

export const Footer = () => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Paper square className={classes.root}>
            <Tabs
                value={value}
                onChange={handleChange}
                variant="fullWidth"
                indicatorColor="secondary"
                textColor="secondary"
                aria-label="icon label tabs example"
            >
                <Tab icon={<Phone />} label="Call" />
                <Tab icon={<Email />} label="E-mail" />
                <Tab icon={<WhatsApp />} label="Message" />
            </Tabs>
        </Paper>
    );
}
